import script from "./IncidenciasView.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidenciasView.vue?vue&type=script&setup=true&lang=js"

import "./IncidenciasView.vue?vue&type=style&index=0&id=b234f3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b234f3ae"]])

export default __exports__